
import CustomerDataPage from '@views/CustomerDataPage.vue'
import CardOwnerDataPage from '@views/CardOwnerDataPage.vue'
import AccountOverviewPage from '@views/AccountOverviewPage.vue'
import InvoiceOverviewPage from '@views/InvoiceOverviewPage.vue'
import BankAccountOwnerDataPage from '@views/BankAccountOwnerDataPage.vue'

//import { keycloakState } from '../lib/state.js'
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/',
        name: 'account-overview-page',
        component: AccountOverviewPage,
        meta: {
            nav: true,
            displayKey: 'general.overview'
        }
    },
    {
        path: '/customer-data/:id',
        name: 'customer-data',
        component: CustomerDataPage,
        meta: {
            //rights: [ 'edit-personal-data' ],
            parentPath: '/'
        }
    },
    {
        path: '/bank-account-owner-data/:id',
        name: 'bank-account-owner-data',
        component: BankAccountOwnerDataPage,
        meta: {
            //rights: [ 'edit-personal-data' ],
            parentPath: '/'
        }
    },
    {
        path: '/card-owner-data/:id',
        name: 'card-owner-data',
        component: CardOwnerDataPage,
        meta: {
            //rights: [ 'edit-personal-data' ],
            parentPath: '/'
        }
    },
    {
        path: '/invoices',
        name: 'invoices',
        component: InvoiceOverviewPage,
        meta: {
            nav: true,
            displayKey: 'general.invoices'
        }
    }
]

const base = process.env.NODE_ENV === 'production' ? '/aboonline-portal' : '/'

const router = createRouter({
    history: createWebHistory(base),
    routes
})

router.beforeEach((to, from, next) => {
    // preserve query
    // we merge both querys in case the to.query is not emtpy
    // parameters present in both querys will be overwritten by the to.query values!
    const fromhasquery = !!Object.keys(from.query).length
    const tohasquery   = !!Object.keys(to.query).length

    if ((fromhasquery && !tohasquery)) {
        Object.assign(to.query, { ...from.query, ...to.query}) // route.query is readonly, so we can't do this: to.query = { ...from.query, ...to.query}
        next(to)
    } else {
        next()
    }
})

export default router
